import { updateLinksAttributes } from '../utils/handleAttributes';
import { missingWidget } from '../utils/helpers';

export default function ticketButton() {
  const widgetName = 'ticketButton';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof ticketButtonOpts === 'undefined' ? null : ticketButtonOpts;

  if (!widgetOpts) {
    $widget.remove();
    missingWidget(widgetName);
    return;
  }

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createTicketButton(data);
      } else {
        $widget.remove();
      }
    },
  });

  function createTicketButton(widgetData) {
    const { Title, URL } = widgetData.items[0];

    if (URL == null) {
      missingWidget(widgetName);
      $widget.remove();
      return;
    }
    $widget.find('.card-widget-item').replaceWith(
      `<a class="tkt-wrapper" tabindex="0" href="${URL}" ${updateLinksAttributes(URL, Title)} aria-label="${Title}">
        <div class="ticket-btn">
          <span class="left-shape">
            <span class="tkt-icon-hat"></span>
          </span>
          <span class="right-shape">${Title}</span>
        </div>
    </a>`,
    );
  }
}
